// extracted by mini-css-extract-plugin
export default {"splash__talk-cancelled":"EndSplash_splash__talk-cancelled__W+eYk","splash__talk-cancelled__header":"EndSplash_splash__talk-cancelled__header__QqlBb","icon":"EndSplash_icon__EJzNP"};